var geoLocationOptions = {
    enableHighAccuracy: false,
    timeout: 3000,
    maximumAge: 0
};

function debugGeoLocationSuccess(position) {
    var coordinates = position.coords;
    console.log("Your current position is:");
    console.log("Latitude : " + coordinates.latitude);
    console.log("Longitude: " + coordinates.longitude);
    console.log("Accuracy: " + coordinates.accuracy + " meters.");
}

function fillGeoLocationElements(position, forceReplace) {

    if (typeof forceReplace === "undefined") {
        forceReplace = false;
    }

    // Detect advanced modifiers (zip, city, state, submit)
    var modifiers = [];
    $('[data-geolocation-fill-location]').each(function () {
        var attr = $(this).attr('data-geolocation-fill-location');
        if (!attr) return;

        var parts = attr.split(',');
        for (var i = 0; i < parts.length; i++) {
            var p = (parts[i] + "").replace(/^\s+|\s+$/g, "").toLowerCase();
            if (p && modifiers.indexOf(p) === -1) {
                modifiers.push(p);
            }
        }
    });

    var usesLatLngOnly = modifiers.indexOf("lat") !== -1 && modifiers.indexOf("lng") !== -1;

    var usesAdvanced =
        (!usesLatLngOnly) && (
            modifiers.indexOf("zip") !== -1 ||
            modifiers.indexOf("city") !== -1 ||
            modifiers.indexOf("state") !== -1
        );

    // Standard (legacy) mode function
    function continueStandardFill() {

        if (getCookie("geolocationCoords") !== null && !forceReplace) {
            return;
        }

        if (getCookie("geolocationCoords") === null || forceReplace) {

            var prefillText = String.format("{0}, {1}",
                position.coords.latitude,
                position.coords.longitude
            );

            var submitFormElement;

            $('[data-geolocation-fill-location]').each(function () {

                if ($(this).is('input')) {

                    if (!$(this).val() || forceReplace) {
                        $(this).val(prefillText);

                        if ($(this).attr('data-geolocation-fill-mask')) {
                            var maskElement = $('#' + $(this).attr('data-geolocation-fill-mask'));
                            maskElement.show();
                            $(this).attr('readonly', true);
                            $(this).addClass("masked-input");
                        }

                        if ($(this).attr('data-geolocation-fill-location') === "submit") {
                            submitFormElement = $(this);
                        }
                    }

                } else {
                    $(this).text(prefillText);
                }
            });

            if (submitFormElement && submitFormElement.length) {
                submitFormElement.closest('form').submit();
            }
        }
    }

    // Legacy cookie check
    if (!usesAdvanced) {
        if (getCookie("geolocationCoords") !== null && !forceReplace) {
            return;
        }
    }

    // LAT,LNG DIRECT MODE  (SKIPS GOOGLE API)
    if (usesLatLngOnly) {

        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        var finalText = lat + "," + lng;

        $('[data-geolocation-fill-location]').each(function () {
            if ($(this).is('input')) {
                $(this).val(finalText);
            } else {
                $(this).text(finalText);
            }
        });

        return;
    }

    // ADVANCED MODE USING GOOGLE REVERSE GEOCODING
    if (usesAdvanced) {

        var lat = position.coords.latitude;
        var lng = position.coords.longitude;

        reverseGeocode(lat, lng, function (address) {

            if (!address) {
                continueStandardFill();
                return;
            }

            var city = address.city || "";
            var state = address.state || "";
            var zip = address.zip || address.postcode || "";

            var outputParts = [];

            if (modifiers.indexOf("city") !== -1 && city) outputParts.push(city);
            if (modifiers.indexOf("state") !== -1 && state) outputParts.push(state);
            if (modifiers.indexOf("zip") !== -1 && zip) outputParts.push(zip);

            var finalText = outputParts.join(", ");

            $('[data-geolocation-fill-location]').each(function () {

                if ($(this).is('input')) {

                    if (!$(this).val() || forceReplace) {
                        $(this).val(finalText);

                        if ($(this).attr('data-geolocation-fill-mask')) {
                            var maskElement2 = $('#' + $(this).attr('data-geolocation-fill-mask'));
                            maskElement2.show();
                            $(this).attr('readonly', true);
                            $(this).addClass("masked-input");
                        }
                    }

                } else {
                    $(this).text(finalText);
                }
            });

            // Auto-submit if requested
            if (modifiers.indexOf("submit") !== -1) {
                var submitEl = $('[data-geolocation-fill-location]').filter(function () {
                    var val = ($(this).attr('data-geolocation-fill-location') || "").toLowerCase();
                    return val.indexOf("submit") !== -1;
                });

                if (submitEl.length) {
                    submitEl.closest('form').submit();
                }
            }
        });

        return;
    }

    // Default: standard mode
    continueStandardFill();
}


// ERROR HANDLING
function geoLocationError(error) {
    console.debug("GEOLOCATION ERROR(" + error.code + "): " + error.message);

    $('[data-geolocation-trigger]').each(function () {
        var errorTargetId = $(this).attr('data-geolocation-error-element');
        var errorTargetElement = $(errorTargetId);
        if (errorTargetElement.length) {
            errorTargetElement.show();
        }
    });

    deleteCookie('geolocationCoords');
}

function hideGeoLocationErrors() {
    $('.geolocation-error').hide();
}


// BROWSER LOCATION GETTER (PRIMARY METHOD)
function getLocation(forceReplace) {

    if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(function (position) {

            hideGeoLocationErrors();
            fillGeoLocationElements(position, forceReplace);
            setGeoCookie(position);
            return true;

        }, geoLocationError, geoLocationOptions);
    }

    return false;
}


// COOKIE STORAGE
window.setGeoCookie = function setGeoCookie(position) {
    var cookie_val = position.coords.latitude + "---" + position.coords.longitude;
    var now = new Date();
    now.setTime(now.getTime() + (1 * 3600 * 1000));
    document.cookie = "geolocationCoords=" + escape(cookie_val) + "; expires=" + now.toUTCString() + "; path=/";
};


// BUTTON CLICK INIT
$(document).ready(function () {
    // Optional auto-run:
    // getLocation(false);
    autoFillLocationOnLoad();
});

function autoFillLocationOnLoad() {

    // --------------------------------------------------------
    // 1. Check query string for "searchlocation"
    // --------------------------------------------------------
    var params = new URLSearchParams(window.location.search);

    if (params.has("searchlocation")) {

        // User submitted a search and field WAS EMPTY
        if (params.get("searchlocation") === "") {
            return; // user intentionally searched without a location
        }

        // Field had a value; do not override it
        return;
    }

    // --------------------------------------------------------
    // 2. If the field already has a value (typed manually), don't autofill
    // --------------------------------------------------------
    var field = $('[data-geolocation-fill-location]');
    var hasValue = false;

    field.each(function () {
        if ($(this).is('input')) {
            if ($(this).val() && $(this).val().length > 0) {
                hasValue = true;
            }
        } else {
            if ($(this).text() && $(this).text().length > 0) {
                hasValue = true;
            }
        }
    });

    if (hasValue) {
        return;
    }

    // --------------------------------------------------------
    // 3. Try autofill from cookie (user previously granted permission)
    // --------------------------------------------------------
    var cookieVal = getCookie("geolocationCoords");
    if (!cookieVal) {
        return; // no saved location, cannot autofill silently
    }

    var parts = cookieVal.split("---");
    if (parts.length !== 2) return;

    var lat = parseFloat(parts[0]);
    var lng = parseFloat(parts[1]);

    if (isNaN(lat) || isNaN(lng)) {
        return;
    }

    var position = {
        coords: {
            latitude: lat,
            longitude: lng
        }
    };

    fillGeoLocationElements(position, false);
}

$('[data-geolocation-trigger]').on('click', function () {
    getLocation(true);
});

// ------------------------------------------------------------
// GOOGLE REVERSE GEOCODING
// ------------------------------------------------------------
function reverseGeocode(lat, lng, callback) {
    var apiKey = getGMIPKey();
    if (!apiKey) {
        callback(null);
        return;
    }

    $.getJSON("https://maps.googleapis.com/maps/api/geocode/json", {
        latlng: lat + "," + lng,
        key: apiKey
    })
        .done(function (data) {

            if (!data || !data.results || !data.results.length) {
                callback(null);
                return;
            }

            var comps = data.results[0].address_components || [];
            var result = { zip: "", city: "", state: "" };

            for (var i = 0; i < comps.length; i++) {
                var c = comps[i];
                if (c.types.indexOf("postal_code") !== -1) result.zip = c.long_name;
                if (c.types.indexOf("locality") !== -1) result.city = c.long_name;
                if (c.types.indexOf("administrative_area_level_1") !== -1) result.state = c.short_name;
            }

            callback(result);
        })
        .fail(function () {
            callback(null);
        });
}


// ------------------------------------------------------------
// GET GOOGLE MAPS KEY FROM <body data-gmip="">
// ------------------------------------------------------------
function getGMIPKey() {
    var body = document.body;
    if (!body) return null;

    var key = body.getAttribute("data-gmip");
    if (!key || key.length === 0) {
        return null;
    }

    return key;
}